// extracted by mini-css-extract-plugin
export var chevron = "_b2-2";
export var dropdownItems = "_b2-0";
export var item = "_b2-1";